import React from 'react'
import { Link } from 'react-router-dom'
import LogoWhite from '../../assets/images/logo-white.png'

const RegisterHeader = () => {
  return (
    <header>
    <nav className="navbar navbar-expand-lg bg-primary">
        <div className="container">
          <Link className="navbar-brand" to="#">
            <img src={LogoWhite} alt="Logo" className="img-fluid"/>
          </Link>
        </div>
      </nav>
    </header>
  )
}

export default RegisterHeader